import { ActionIcon, Indicator, Tooltip } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useLanguage } from '@contexts/LanguageContext';
import { useTheme } from '@contexts/ThemeContext';
import { useAppUpdateState } from '@hooks/use-app-update';

/** Matches the bell and history icons it sits next to. */
const ICON_SIZE = 20;

/**
 * What the update banner leaves behind once closed: a way to pick the new
 * build up on the user's own schedule without changing page. Shown only after
 * a dismissal — before that the banner is the reminder, and before the banner
 * nothing is shown at all.
 */
export default function AppUpdateHeaderButton() {
  const { t } = useLanguage();
  const { colors: themeColors } = useTheme();
  const { deployed, dismissed, required } = useAppUpdateState();

  if (deployed === null || !dismissed || required) return null;
  const label = t('appUpdate.header.tooltip');

  return (
    <Tooltip label={label} withArrow>
      <Indicator size={8} offset={6} color="blue">
        <ActionIcon
          variant="subtle"
          size="lg"
          radius="xl"
          aria-label={label}
          onClick={() => window.location.reload()}
          style={{ color: themeColors.text }}
        >
          <IconRefresh size={ICON_SIZE} strokeWidth={1.6} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  );
}
